export default class Document {
  id;
  name;
  createdDateTime;
  lastModifiedDateTime;
  webUrl;
  size;
  createdBy;
  lastModifiedBy;
  parentReference;
  folder;
  children;
  extension;
  itemId;

  constructor(apiDocument) {
    if (apiDocument) {
      this.id = apiDocument.id;
      this.name = apiDocument.name;
      this.createdDateTime = apiDocument.createdDateTime ? new Date(apiDocument.createdDateTime) : null;
      this.lastModifiedDateTime = apiDocument.lastModifiedDateTime ? new Date(apiDocument.lastModifiedDateTime) : null;
      this.webUrl = apiDocument.webUrl;
      this.size = apiDocument.size ? Number(apiDocument.size) : null;
      this.createdBy = apiDocument.createdBy;
      this.lastModifiedBy = apiDocument.lastModifiedBy;
      this.parentReference = apiDocument.parentReference;
      this.folder = apiDocument.folder;
      this.children = apiDocument.children;
      this.extension = apiDocument.extension;
      this.itemId = apiDocument.itemId;
    }
  }

  get sizeAsString() {
    if (typeof this.size === "number") {
      let bytes = this.size;
      const si = true;
      // credits: https://stackoverflow.com/a/14919494
      const thresh = si ? 1000 : 1024;

      if (Math.abs(bytes) < thresh) {
        return bytes + " B";
      }

      const units = si
        ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
        : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];

      let u = -1;

      do {
        bytes /= thresh;
        ++u;
      } while (Math.abs(bytes) >= thresh && u < units.length - 1);

      return bytes.toFixed(1) + " " + units[u];
    }
    return "";
  }

  static fromQuickShare(apiDocument) {
    const qsDocument = new Document();

    if (apiDocument.filename) {
      qsDocument.name = apiDocument.filename;
    }

    if (apiDocument.filesize) {
      qsDocument.size = Number(apiDocument.filesize);
    }

    if (apiDocument.created) {
      qsDocument.createdDateTime = new Date(apiDocument.created);
    }

    return qsDocument;
  }
}
